// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*@media (min-width: 768px) and (max-width: 1023px) {*/
/*#singlecourse .body .info .infoHolder {*/
/*width: 100%;*/
/*}*/

/*#singlecourse .body .info .mainImg {*/
/*width: 100%;*/
/*}*/

/*#singlecourse .body .info .content {*/
/*width: 100%;*/
/*}*/

/*.modal-body .navbar-form .form-group .form-control {*/
/*width: 100%;*/
/*}*/

/*#accounts .col-md-12 .form-group {*/
/*width: 100%;*/
/*}*/

/*#courses .certInfo .name {*/
/*font-size: 40px;*/
/*top: 35%;*/
/*}*/

/*#courses .certInfo .score {*/
/*font-size: 40px;*/
/*right: 7%;*/
/*}*/

/*#courses .certInfo .completionDate {*/
/*bottom: 21%;*/
/*font-size: 20px;*/
/*left: 7%;*/
/*}*/
/*}*/

/*@media (min-width: 1024px) and (max-width: 1299px) {*/
/*.modal-body .navbar-form .form-group .form-control {*/
/*width: 100%;*/
/*}*/

/*#courses .certInfo .name {*/
/*top: 37%;*/
/*}*/

/*#courses .certInfo .score {*/
/*font-size: 50px;*/
/*right: 7%;*/
/*}*/

/*#courses .certInfo .completionDate {*/
/*bottom: 21%;*/
/*left: 7%;*/
/*}*/
/*}*/

@media (min-width: 1300px) and (max-width: 1399px) {
  .container {
    width: 1270px;
  }

  /*.modal-body .navbar-form .form-group .form-control {*/
  /*width: 100%;*/
  /*}*/

  /*#courses .certInfo .score {*/
  /*right: 8%;*/
  /*}*/
}

@media (min-width: 768px) {
  .modal-dialog {
    width: 800px;
    margin: 30px auto;
  }
}

@media (min-width: 1400px) {
  .container {
    width: 1370px;
  }

  /*.modal-body .navbar-form .form-group .form-control {*/
  /*width: 100%;*/
  /*}*/

  /*#courses .certInfo .score {*/
  /*right: 10%;*/
  /*}*/

  /*#courses .certInfo .completionDate {*/
  /*bottom: 22%;*/
  /*left: 9%;*/
  /*}*/
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/components/mediaqueries.css"],"names":[],"mappings":"AAAA,sDAAsD;AACtD,0CAA0C;AAC1C,eAAe;AACf,IAAI;;AAEJ,uCAAuC;AACvC,eAAe;AACf,IAAI;;AAEJ,uCAAuC;AACvC,eAAe;AACf,IAAI;;AAEJ,uDAAuD;AACvD,eAAe;AACf,IAAI;;AAEJ,qCAAqC;AACrC,eAAe;AACf,IAAI;;AAEJ,6BAA6B;AAC7B,mBAAmB;AACnB,YAAY;AACZ,IAAI;;AAEJ,8BAA8B;AAC9B,mBAAmB;AACnB,aAAa;AACb,IAAI;;AAEJ,uCAAuC;AACvC,eAAe;AACf,mBAAmB;AACnB,YAAY;AACZ,IAAI;AACJ,IAAI;;AAEJ,uDAAuD;AACvD,uDAAuD;AACvD,eAAe;AACf,IAAI;;AAEJ,6BAA6B;AAC7B,YAAY;AACZ,IAAI;;AAEJ,8BAA8B;AAC9B,mBAAmB;AACnB,aAAa;AACb,IAAI;;AAEJ,uCAAuC;AACvC,eAAe;AACf,YAAY;AACZ,IAAI;AACJ,IAAI;;AAEJ;EACE;IACE,aAAa;EACf;;EAEA,uDAAuD;EACvD,eAAe;EACf,IAAI;;EAEJ,8BAA8B;EAC9B,aAAa;EACb,IAAI;AACN;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA,uDAAuD;EACvD,eAAe;EACf,IAAI;;EAEJ,8BAA8B;EAC9B,cAAc;EACd,IAAI;;EAEJ,uCAAuC;EACvC,eAAe;EACf,YAAY;EACZ,IAAI;AACN","sourcesContent":["/*@media (min-width: 768px) and (max-width: 1023px) {*/\n/*#singlecourse .body .info .infoHolder {*/\n/*width: 100%;*/\n/*}*/\n\n/*#singlecourse .body .info .mainImg {*/\n/*width: 100%;*/\n/*}*/\n\n/*#singlecourse .body .info .content {*/\n/*width: 100%;*/\n/*}*/\n\n/*.modal-body .navbar-form .form-group .form-control {*/\n/*width: 100%;*/\n/*}*/\n\n/*#accounts .col-md-12 .form-group {*/\n/*width: 100%;*/\n/*}*/\n\n/*#courses .certInfo .name {*/\n/*font-size: 40px;*/\n/*top: 35%;*/\n/*}*/\n\n/*#courses .certInfo .score {*/\n/*font-size: 40px;*/\n/*right: 7%;*/\n/*}*/\n\n/*#courses .certInfo .completionDate {*/\n/*bottom: 21%;*/\n/*font-size: 20px;*/\n/*left: 7%;*/\n/*}*/\n/*}*/\n\n/*@media (min-width: 1024px) and (max-width: 1299px) {*/\n/*.modal-body .navbar-form .form-group .form-control {*/\n/*width: 100%;*/\n/*}*/\n\n/*#courses .certInfo .name {*/\n/*top: 37%;*/\n/*}*/\n\n/*#courses .certInfo .score {*/\n/*font-size: 50px;*/\n/*right: 7%;*/\n/*}*/\n\n/*#courses .certInfo .completionDate {*/\n/*bottom: 21%;*/\n/*left: 7%;*/\n/*}*/\n/*}*/\n\n@media (min-width: 1300px) and (max-width: 1399px) {\n  .container {\n    width: 1270px;\n  }\n\n  /*.modal-body .navbar-form .form-group .form-control {*/\n  /*width: 100%;*/\n  /*}*/\n\n  /*#courses .certInfo .score {*/\n  /*right: 8%;*/\n  /*}*/\n}\n\n@media (min-width: 768px) {\n  .modal-dialog {\n    width: 800px;\n    margin: 30px auto;\n  }\n}\n\n@media (min-width: 1400px) {\n  .container {\n    width: 1370px;\n  }\n\n  /*.modal-body .navbar-form .form-group .form-control {*/\n  /*width: 100%;*/\n  /*}*/\n\n  /*#courses .certInfo .score {*/\n  /*right: 10%;*/\n  /*}*/\n\n  /*#courses .certInfo .completionDate {*/\n  /*bottom: 22%;*/\n  /*left: 9%;*/\n  /*}*/\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
